<template>
  <div class="p-0 mb-8" :title="$t('fees')">
    <vs-button @click="popupActive12=true" color="primary">
      Configuration globale
    </vs-button>
    <vs-popup fullscreen title="Configuration globale" :active.sync="popupActive12">
      <vs-tabs>
        <vs-tab label="Les classes concernées par cette configuration" icon-pack="feather" icon="icon-box">
          <vs-list>
            <vs-list-item :title="$t('Select_all')">
              <vs-checkbox slot="avatar" color="success" v-model="list1CheckBox"></vs-checkbox>

            </vs-list-item>

            <vs-list-item v-for="(classe, index) in temponClasses" :key="index" @click="classe.checkBox = classe.checkBox ? false : true" :title="classe.libelle">
              <vs-checkbox slot="avatar" color="success" v-model="classe.checkBox"></vs-checkbox>

              <vs-chip color="success">
                <b>
                  {{ index + 1 }}

                </b>
              </vs-chip>
            </vs-list-item>
          </vs-list>
        </vs-tab>
        <vs-tab label="Configuration" icon-pack="feather" icon="icon-home">
            <form data-vv-scope="step-histech999999999-485">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5">
                  <p class="mb-4">
                    {{ $t('Student_status') }}
                    <b style="color: #ff6141;">*</b>
                  </p>
                  <v-select
                    multiple
                    :options="statutEleves"
                    @search="getStatutEleve"
                    :clearable="true"
                    :closeOnSelect="false"
                    label="libelle"
                    v-model="statutEleves_add"
                    class="w-full"
                    name="classestudentstatus"
                    v-validate="'required'"
                  />
                  <span class="text-danger" v-if="!statutEleves_add.length">
                    Veuillez bien choisir au moins un status
                  </span>
                </div>
                <div class="vx-col md:w-1/4 w-full mt-5">
                  <p class="mb-4">
                    {{ $t('Amount') }}
                    <b style="color: #ff6141;">*</b>
                  </p>
                  <vs-input-number
                    class="ml-0 w-full"
                    v-model="montant"
                    name="classemontant"
                    v-validate="'required'"
                  />
                  <span class="text-danger" v-if="!montant">
                    Veuillez bien entrer le montant
                  </span>
                </div>

                <div class="vx-col md:w-1/4 w-full mt-5">
                  <p class="mb-4">
                    {{ $t('number_of_slice') }}
                    <b style="color: #ff6141;">*</b>
                  </p>
                  <vs-input-number
                    class="ml-0 w-full"
                    v-model="nombreDeTranche"
                    name="classenombreDeTranche"
                    v-validate="'required'"
                  />
                  <span class="text-danger" v-if="!nombreDeTranche">
                    Veuillez bien entrer le nombre de tranche
                  </span>
                </div>

                <div
                  :key="trancheindexItem"
                  v-for="(tranche, trancheindexItem) in tranches"
                  class="vx-col md:w-1/2 w-full mt-5"
                >
                  <vs-list>
                    <vs-list-header
                      icon-pack="feather"
                      icon="icon-crop"
                      :title="'Tranche ' + (trancheindexItem + 1)"
                    ></vs-list-header>
                    <vs-list-item
                      icon-pack="feather"
                      icon="icon-dollar-sign"
                      :title="$t('Amount')"
                    >
                      <vs-input-number
                        class="ml-0 w-full"
                        v-model="tranche.montant"
                        :name="
                          'classemontant' + (trancheindexItem + 1)
                        "
                        v-validate="'required'"
                      />
                      <span class="text-danger" v-if="!tranche.montant">
                        Veuillez bien entrer le montant
                      </span>
                    </vs-list-item>
                    <vs-list-item
                      icon-pack="feather"
                      icon="icon-calendar"
                      :title="$t('Start_date')"
                    >
                      <datepicker
                        v-model="tranche.dateDebut"
                        :name="
                          'classedateDebut' + (trancheindexItem + 1)
                        "
                        v-validate="'required'"
                      ></datepicker>
                      <span class="text-danger" v-if="!tranche.dateDebut">
                        Veuillez bien entrer la date de debut
                      </span>
                    </vs-list-item>
                    <vs-list-item
                      icon-pack="feather"
                      icon="icon-calendar"
                      :title="$t('End_date')"
                    >
                      <datepicker
                        v-model="tranche.dateFin"
                        :name="
                          'classedateFin' + (trancheindexItem + 1)
                        "
                        v-validate="'required'"
                      ></datepicker>
                      <span class="text-danger" v-if="!tranche.dateFin">
                        Veuillez bien entrer la date de fin
                      </span>
                    </vs-list-item>
                  </vs-list>
                </div>
              </div>

              <br v-if="popupActive12">
              <br v-if="popupActive12">
              <br v-if="popupActive12">
              <br v-if="popupActive12">
              <br v-if="popupActive12">
              <br v-if="popupActive12">
              <br v-if="popupActive12">
              <br v-if="popupActive12">
              <br v-if="popupActive12">
              <br v-if="popupActive12">
              <br v-if="popupActive12">
              <br v-if="popupActive12">

              <vs-button
                class="mt-5"
                icon-pack="feather"
                icon="icon-check"
                @click="formatAll()"
              >
                Valider
              </vs-button>
            </form>
        </vs-tab>
      </vs-tabs>
    </vs-popup>

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
export default {
  props: {
    temponClasses: {
      type: Array,
      default: () => { return [] },
      required: false
    },
    statutEleves: {
      type: Array,
      default: () => { return [] },
      required: false
    },
    frais_input: {
      type: Object,
      required: false
    },
    frais_input1: {
      type: Object,
      required: false
    },
    getStatutEleve: {
      type: Function
    }
  },
  watch: {
    list1CheckBox (value) {
      const length = this.temponClasses.length
      for (let i = 0; i < length; i++) {
        this.temponClasses[i].checkBox = value
      }
    },
    nombreDeTranche (value) {
      const tranches = []
      for (let i = 0; i < value; i++) {
        tranches.push({
          montant: 0,
          dateDebut: null,
          dateFin: null
        })
      }

      this.tranches = tranches
    }
  },
  data () {
    return {
      statutEleves_add: [],
      montant: 0,
      nombreDeTranche: 0,
      tranches: [],
      list1CheckBox: false,
      popupActive12: false,
      frais_input222: {}
    }
  },
  methods: {
    init () {
      this.statutEleves_add = []
      this.montant = 0
      this.nombreDeTranche = 0
      this.tranches = []
      this.list1CheckBox = false
    },
    affectElement (classe) {
      const tranches = this.frais_input222[classe.id].tranches
      /* console.log('classe: ', classe)
      console.log('tranches: ', tranches) */

      this.frais_input222[classe.id].statutEleves_add = JSON.parse(JSON.stringify(this.statutEleves_add))
      this.frais_input222[classe.id].montant = JSON.parse(JSON.stringify(this.montant))
      this.frais_input222[classe.id].nombreDeTranche = JSON.parse(JSON.stringify(this.nombreDeTranche))
      this.frais_input222[classe.id].tranches = JSON.parse(JSON.stringify(this.tranches))

      for (let i = 0; i < tranches.length; i++) {

        if (i < this.frais_input222[classe.id].tranches.length) {
          this.frais_input222[classe.id].tranches[i].id = tranches[i].id
        }
      }

      this.frais_input1[classe.id] = JSON.parse(JSON.stringify(this.frais_input222[classe.id]))
      this.frais_input[classe.id] = JSON.parse(JSON.stringify(this.frais_input222[classe.id]))
    },
    formatAll () {
      this.frais_input222 = JSON.parse(JSON.stringify(this.frais_input1))
      const length = this.temponClasses.length
      for (let i = 0; i < length; i++) {

        if (this.temponClasses[i].checkBox) {
          this.affectElement(this.temponClasses[i])
        }

        this.temponClasses[i].checkBox = false
      }

      this.popupActive12 = false
      /* this.frais_input1 = JSON.parse(JSON.stringify(this.frais_input222))
      this.frais_input = JSON.parse(JSON.stringify(this.frais_input222)) */
      this.init()
    }
  },
  components: {
    Datepicker
  },
  created () {}
}
</script>
